import type { ContractSign } from '@/api/reservations/types';

function isContractSigned(resData: ContractSign | undefined): boolean {
  return !!resData?.contractSignedAt;
}

function hasOutstandingBalance(resData: ContractSign | undefined): boolean {
  return (resData?.outstandingBalance ?? 0) > 0;
}

export function shouldRedirectFromContractSign(
  resData: ContractSign | undefined
): boolean {
  return isContractSigned(resData) && !hasOutstandingBalance(resData);
}

export function needsPaymentOnly(resData: ContractSign | undefined): boolean {
  return isContractSigned(resData) && hasOutstandingBalance(resData);
}

export function getScreenTitle(
  resData: ContractSign | undefined,
  stripeClientSecret: string | null
): string {
  if (needsPaymentOnly(resData)) return 'Complete Payment';
  if (stripeClientSecret) return 'Sign and Pay';
  return 'Sign Contract';
}

export async function waitForBalanceCleared(
  refetch: () => Promise<{ data?: ContractSign }>
): Promise<boolean> {
  for (let attempt = 0; attempt < 4; attempt += 1) {
    const res = await refetch();
    if ((res.data?.outstandingBalance ?? 0) === 0) {
      return true;
    }

    if (attempt < 3) {
      await new Promise((resolve) => setTimeout(resolve, 5000));
    }
  }

  return false;
}
